<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Performance Inputs</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (espSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">External Static Pressure:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="espSelection.Value"
                (change)="textSelectionChanged(espSelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(espSelection.Name)"/>
              <label class="units-label">InWC</label>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (altitudeSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Altitude:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="altitudeSelection.Value"
                (change)="textSelectionChanged(altitudeSelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(altitudeSelection.Name)"/>
              <label class="units-label">Feet</label>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (fluidTypeSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Fluid Type:</label>
              <select class="halfWidthInputField" #fluidTypeInput
                [class.invalidConfigurationSelection]="isInvalidSelection(fluidTypeSelection.Name)"
                (change)="selectionChanged(fluidTypeSelection, fluidTypeInput.value)"
                [value]="fluidTypeSelection.Value.toString()">
                @for (allowable of fluidTypeSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="fluidTypeSelection.Value && fluidTypeSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (antifreezeConcentrationSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Antifreeze:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="antifreezeConcentrationSelection.Value"
                (change)="textSelectionChanged(antifreezeConcentrationSelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(antifreezeConcentrationSelection.Name)"/>
              <label class="units-label">%</label>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (loadInputSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Load Selection:</label>
              <select class="halfWidthInputField" #loadSelectionInput
                [class.invalidConfigurationSelection]="isInvalidSelection(loadInputSelection.Name)"
                (change)="selectionChanged(loadInputSelection, loadSelectionInput.value)"
                [value]="loadInputSelection.Value.toString()">
                @for (allowable of loadInputSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="loadInputSelection.Value && loadInputSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
          @if (fanSpeedSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Fan Speed:</label>
              <select class="halfWidthInputField" #fanSpeedInput
                [class.invalidConfigurationSelection]="isInvalidSelection(fanSpeedSelection.Name)"
                (change)="selectionChanged(fanSpeedSelection, fanSpeedInput.value)"
                [value]="fanSpeedSelection.Value.toString()">
                @for (allowable of fanSpeedSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="fanSpeedSelection.Value && fanSpeedSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (loadFluidFlowSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Load Fluid Flow Rate:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="loadFluidFlowSelection.Value"
                (change)="textSelectionChanged(loadFluidFlowSelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(loadFluidFlowSelection.Name)"/>
              <label class="units-label">GPM</label>
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>
